import i18n from '~/i18n';
import { checkDuplicated } from '~/utils';

const validateRequired = (value) => {
  if (value === null || value === undefined || String(value).trim() === '') {
    return { isValid: false, helperText: i18n.t('validation:RequiredField') };
  }
  return null;
};

const validateMaxLength64 = (value) => {
  if (String(value).length > 64) {
    return { isValid: false, helperText: i18n.t('validation:maxLength64') };
  }
  return null;
};

const validateOnlyNumbers = (value) => {
  if (value === '' || value === undefined || value === null) {
    return null;
  }
  if (!/^\d+$/.test(String(value))) {
    return { isValid: false, helperText: i18n.t('validation:JustNumbers') };
  }
  return null;
};

const validateValidChars = (value) => {
  const regex = /^[\p{L}\p{N}\s\-_|+()'º./]+$/u;
  if (!regex.test(String(value))) {
    return { isValid: false, helperText: i18n.t('validation:validChars') };
  }
  return null;
};

const duplicated = (tableData, field, value, tableRef) => (
  checkDuplicated(tableData, field, value, tableRef) && {
    isValid: false,
    helperText: i18n.t('validation:DuplicatedRegister'),
  }
);

export const validateIdEquip = ({ id_equip }) => (
  validateRequired(id_equip) || { isValid: true }
);

export const validateName = ({ name, tableData }, tableRef) => (
  validateValidChars(name)
    || validateMaxLength64(name)
    || validateRequired(name)
    || duplicated(tableData, 'name', name, tableRef)
    || { isValid: true }
);

export const validateDescription = ({ description }) => (
  validateRequired(description)
    || validateMaxLength64(description)
    || { isValid: true }
);

export const validatePassword = ({ password }) => (
  validateRequired(password) || validateOnlyNumbers(password) || { isValid: true }
);

export const validateWeighingTare = ({ weighing_tare }) => (
  validateOnlyNumbers(weighing_tare) || { isValid: true }
);

export const validateLicensePlate = ({ license_plate, tableData }, tableRef) => {
  if (license_plate == null || String(license_plate).trim() === '') {
    return { isValid: true };
  }
  return duplicated(tableData, 'license_plate', license_plate, tableRef) || { isValid: true };
};

export const validateIsReserve = ({ is_reserve }) => (
  validateRequired(is_reserve) || { isValid: true }
);

export const validateCompany = ({ company }) => (
  validateMaxLength64(company) || { isValid: true }
);

export const validateIdGroup = ({ id_group }) => {
  if (['', '0', 0].includes(id_group)) {
    return { isValid: false, helperText: i18n.t('validation:RequiredField') };
  }
  return { isValid: true };
};

const EQUIPS_WITH_STANDARD_LOAD = ['1', '2', '15', '29'];

export const isEquipWithStandardLoad = equip_id => (
  EQUIPS_WITH_STANDARD_LOAD.includes(String(equip_id))
);

export const validateStandardLoad = ({ id_equip, standard_load }) => {
  if (!isEquipWithStandardLoad(id_equip)) {
    return { isValid: true };
  }
  if (standard_load === null || standard_load === undefined || String(standard_load).trim() === '') {
    return { isValid: false, helperText: i18n.t('validation:RequiredField') };
  }
  if (!/^\d+([.]\d+)?$/.test(String(standard_load))) {
    return { isValid: false, helperText: i18n.t('validation:JustNumbers') };
  }
  return { isValid: true };
};

export const validateActive = (
  { id, active },
  { loadAllocations = [], truckAllocations = [] } = {},
) => {
  if (Number(active) !== 0) {
    return { isValid: true };
  }

  const equipmentId = Number(id);
  const isAllocated = [...loadAllocations, ...truckAllocations]
    .some(allocation => Number(allocation.equip_id) === equipmentId);

  if (isAllocated) {
    return {
      isValid: false,
      helperText: i18n.t('validation:EquipmentAllocatedCannotDeactivate'),
    };
  }

  return { isValid: true };
};
